import React, { useState, useEffect } from 'react';

const Headline = () => {
  const text = "1.67 Lakh+ Cases Calculated and Solved with 100% Accuracy";
  const words = text.split(' ');
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % text.replace(/\s+/g, '').length);
    }, 100); // Adjust the interval for faster or slower animation
    return () => clearInterval(interval);
  }, [text]);

  return (
    <div
      className="w-full text-center p-1 animate__animated animate__fadeInDown animate__delay-0.5s"
      style={{
        backgroundColor: '#4CAF50',
        marginTop: 80,
        fontSize: '1.5rem', // Reduced font size
      }}
    >
      {words.map((word, wordIndex) => (
        <span key={wordIndex} className="inline-block mx-2">
          {word.split('').map((letter, letterIndex) => {
            const globalIndex = words
              .slice(0, wordIndex)
              .join(' ')
              .replace(/\s+/g, '').length + letterIndex;

            return (
              <span
                key={letterIndex}
                className={`font-bold text-[#fdfdfd] inline-block transition-transform duration-300 transform ${
                  activeIndex === globalIndex ? 'scale-125' : 'scale-100'
                }`}
                style={{
                  fontSize: window.innerWidth < 768 ? '1rem' : '1.75rem', // Adjust font size for mobile
                  transition: 'transform 0.3s ease', // Smooth transition
                }}
              >
                {letter}
              </span>
            );
          })}
        </span>
      ))}
    </div>
  );
};

export default Headline;
